import { Link } from "react-router-dom";
import { Phone, Mail, Clock, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SITE } from "@/data/site";

export default function ContactSection() {
  return (
    <section className="bg-slate-50">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
        <div className="mb-10 flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-sky-700">Help</span>
            <h2 className="mt-2 font-heading text-3xl font-black tracking-tight text-slate-900 sm:text-4xl">
              Need Help Choosing Equipment?
            </h2>
            <p className="mt-2 max-w-xl text-sm text-slate-600">
              Have a question before you order? Reach out and we'll help you find the right equipment.
            </p>
          </div>
          <Button asChild className="rounded-sm bg-sky-700 hover:bg-sky-800" data-testid="contact-section-cta">
            <Link to="/contact">
              Contact us <ArrowRight className="h-4 w-4" />
            </Link>
          </Button>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          <a
            href={SITE.phoneHref}
            className="flex items-start gap-4 rounded-sm border border-slate-200 bg-white p-6 transition-colors duration-200 hover:border-sky-700"
            data-testid="contact-section-phone"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-sm bg-sky-50 text-sky-700">
              <Phone className="h-5 w-5" />
            </span>
            <span>
              <span className="block text-xs font-semibold uppercase tracking-widest text-slate-500">Phone</span>
              <span className="mt-1 block font-heading text-lg font-bold text-slate-900">{SITE.phone}</span>
              <span className="text-xs text-slate-500">Tap to call</span>
            </span>
          </a>

          <a
            href={SITE.emailHref}
            className="flex items-start gap-4 rounded-sm border border-slate-200 bg-white p-6 transition-colors duration-200 hover:border-sky-700"
            data-testid="contact-section-email"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-sm bg-sky-50 text-sky-700">
              <Mail className="h-5 w-5" />
            </span>
            <span className="min-w-0">
              <span className="block text-xs font-semibold uppercase tracking-widest text-slate-500">Email</span>
              <span className="mt-1 block truncate font-heading text-lg font-bold text-slate-900">{SITE.email}</span>
              <span className="text-xs text-slate-500">Tap to email</span>
            </span>
          </a>

          <div className="flex items-start gap-4 rounded-sm border border-slate-200 bg-white p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-sm bg-sky-50 text-sky-700">
              <Clock className="h-5 w-5" />
            </span>
            <span>
              <span className="block text-xs font-semibold uppercase tracking-widest text-slate-500">Business Hours</span>
              <span className="mt-1 block text-sm text-slate-600">Contact us for availability</span>
              <span className="text-xs text-slate-400">Phone &amp; email monitored daily</span>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
